import { TeamsAppId, AppPageIdFlavor } from "@ms/uno-constants/lib/local/AppConstants";
/**
 * The prefix for PPE Channel Tab PageId
 * Here's an example:
 * teamstasksppe.channelTab_19:PS0P_nk0KOFz7EyHvY-dHkflczHoc3UcqB-vy2P9bK81@thread.tacv2_plan:9ZVwTwC5Z0u7ucV7_utvVJUAE6PQ
 */ export const PpeChannelTabPageIdPrefix = "teamstasksppe.channelTab";
/**
 * To generate DeepLink to our UNO app, we need AppId and PageId appropriate to the app flavor
 *
 * For Tasks PPE app, our deep link would start with:
 * https://teams.microsoft.com/l/entity/9c0fcd8d-7cca-466f-b549-9254dac9c036/teamstasksppe.personalApp.mytasks?
 *
 * For Tasks Prod app, our deep link would start with:
 * https://teams.microsoft.com/l/entity/com.microsoft.teamspace.tab.planner/mytasks
 *
 * Meta Hubs SDK provides the PageId (appropriate to given app flavor), and we use this to determine the correct AppId
 */ export const pageIdToAppIdMap = {
    [AppPageIdFlavor.Dev]: TeamsAppId.Dev,
    [AppPageIdFlavor.PPE]: TeamsAppId.PPE,
    [AppPageIdFlavor.Prod]: TeamsAppId.Prod
};
